/**
 * OpenLayer通用方法
 */

import { transform, fromLonLat } from "ol/proj";
import { Overlay, Feature } from "ol";
import { Vector as VectorLayer } from "ol/layer";
import { GeoJSON } from "ol/format";
import { Vector as VectorSource } from "ol/source";
import WebGLPointsLayer from "ol/layer/WebGLPoints";
import { Point } from "ol/geom"; 
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text,
} from "ol/style";

const markerImage = require("../assets/image/defect.png");
// const defectjson = require("../../public/data/json/defectpoint.json");

const oMapUtil = {
  From3857To4326(coord) {
    return transform(coord, "EPSG:3857", "EPSG:4326");
  },

  From4326To3857(coord) {
    return transform(coord, "EPSG:4326", "EPSG:3857");
  },

  /**
   * 按像素平移地图
   * @param {*} x
   * @param {*} y
   */
  PanByPixel(x, y, zoom) {
    const mapCenter = olMap.getView().getCenter(); // 获取当前地图中心点（投影坐标）
    const centerPix = olMap.getPixelFromCoordinate(mapCenter); // 投影坐标转为像素坐标
    const newX = centerPix[0] - x; // 平移横坐标
    const newY = centerPix[1] - y; // 平移纵坐标
    olMap.getView().animate({
      center: olMap.getCoordinateFromPixel([newX, newY]), // 平移后的像素坐标转投影坐标
      duration: 400,
      zoom: zoom || olMap.getView().getZoom(),
    }); // 如果不需要动画效果，也可以直接用setCenter和setZoom方法移动地图
  },

  /**
   * 地图飞行
   * @param {*} center
   * @param {*} duration
   * @param {*} zoom
   */
  MapAnimateTo(center, duration = 400, zoom) {
    olMap.getView().animate({
      center: center,
      duration: duration,
      zoom: zoom || olMap.getView().getZoom(),
    });
  },

  /**
   * 添加一个圆形 Marker
   * @param lngLat
   * @param el
   */
  addOneMarker(lngLat, el = null) {
    const tempEl = document.createElement("div");
    tempEl.className = "simple-circle-marker";
    const marker = new Overlay({
      position: fromLonLat(lngLat),
      positioning: "center-center",
      element: el || tempEl,
      stopEvent: false,
    });
    olMap.addOverlay(marker);
  },

  /**
   *
   * @param source
   * @param style
   */
  addVectorLayer(source, style) {
    const vectorLayer = new VectorLayer({
      source: source,
      style: style,
    });
  },

  /**
   * 快速添加WbeGlPoint图层
   * @param {*} layerId
   * @param {*} geoJson
   * @param {*} style
   */
  addWebGLPointsLayer(layerId, dataitem) {
    // layerId 唯一性
    olMap.getLayers().forEach((layer) => {
      // eslint-disable-next-line no-prototype-builtins
      if (
        layer &&
        layer.values_ &&
        layer.values_.hasOwnProperty("id") &&
        layerId === layer.get("id")
      ) {
        throw new Error(`addGeojsonLayer: 图层id：${layerId}重复`);
      }
    });

    console.log("到这里44");
    console.log(dataitem, "到这里dataitem44");

    let style = {
      symbol: {
        symbolType: "image",
        size: 3,
        color: "#ff0000",
      },
    };

    let iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 20],
        anchorXUnits: "fraction",
        anchorYUnits: "pixels",
        src: markerImage,
        scale: 0.5, // 大小百分比
      }),
    });
  
    let features = [];
    console.log("到这里55");
    console.log(dataitem[0].geometry, "dataitem[0].geometry");

    let cd = JSON.parse(dataitem[1].geometry);

    console.log(cd.coordinates, "cd.coordinates");
    for (let i = 0; i < dataitem.length; i++) {
      let geom = null;
      if (dataitem[i].geometry) {
        geom = JSON.parse(dataitem[i].geometry);
      }
      let lon = geom.coordinates[0];
      let lat = geom.coordinates[1];
      let feature = new Feature({
          geometry: new Point([lon, lat]),
      });
      
    //   let style = new Style({
    //     image: new Icon({
    //         scale: 0.8,
    //         src: markerImage,
    //         anchor: [0.48, 0.52]
    //     }),
    //     text: new Text({
    //         font: 'normal 12px 黑体',
    //         // // 对其方式
    //         textAlign: 'center',
    //         // 基准线
    //         textBaseline: 'middle',
    //         offsetY: -35,
    //         offsetX: 0,
    //         backgroundFill: new Stroke({
    //             color: 'rgba(0,0,255,0.7)',
    //         }),
    //         // 文本填充样式
    //         fill: new Fill({
    //             color: 'rgba(236,218,20,1)'
    //         }),
    //         padding: [5, 5, 5, 5],
    //         text:'',
    //     })
    // })
  

      features.push(feature);
    }
    console.log("到这里66");
    let vectorSource = new VectorSource({
      features: features,
    });
    console.log("到这里77");

    let layer = new WebGLPointsLayer({
      source: vectorSource,
      style:style,
      disableHitDetection: true,
    });
    olMap.addLayer(layer);
  },


    /**
   * 快速添加WbeGlPoint图层
   * @param {*} layerId
   * @param {*} geoJson
   * @param {*} style
   */
     addWebGLPointsLayer2(layerId) {
      // layerId 唯一性
      olMap.getLayers().forEach((layer) => {
        // eslint-disable-next-line no-prototype-builtins
        if (
          layer &&
          layer.values_ &&
          layer.values_.hasOwnProperty("id") &&
          layerId === layer.get("id")
        ) {
          throw new Error(`addGeojsonLayer: 图层id：${layerId}重复`);
        }
      });
  
      console.log("到这里44");
    
  
      // const vectorSource = new VectorLayer({
      //   url:defectjson ,
      //   format: new GeoJSON(),
      // });
      
      // console.log("到这里5544");


      const newStyle= {
        "symbol": {
          symbolType: 'image',
          src: './static/icon/location.png',
          size: [28, 28],
          rotateWithView: true
        }
      };
        let style = new Style({
        image: new Icon({
            scale: 0.8,
            src: markerImage,
            anchor: [0.48, 0.52]
        }),
        text: new Text({
            font: 'normal 12px 黑体',
            // // 对其方式
            textAlign: 'center',
            // 基准线
            textBaseline: 'middle',
            offsetY: -35,
            offsetX: 0,
            backgroundFill: new Stroke({
                color: 'rgba(0,0,255,0.7)',
            }),
            // 文本填充样式
            fill: new Fill({
                color: 'rgba(236,218,20,1)'
            }),
            padding: [5, 5, 5, 5],
            text:'',
        })
    })

      // let layer  = new WebGLPointsLayer({
      //   source: vectorSource,
      //   style: newStyle,
      //   disableHitDetection: true,
      // });

      // console.log(layer)
      // console.log("到这里6644");
      // olMap.addLayer(layer);

      console.log("到这里7744");
      
      
    },

  /**
   * 快速添加GeoJson图层
   * @param {*} layerId
   * @param {*} geoJson
   * @param {*} style
   */
  addGeojsonLayer(layerId, geoJson, style) {
    // layerId 唯一性
    olMap.getLayers().forEach((layer) => {
      // eslint-disable-next-line no-prototype-builtins
      if (
        layer &&
        layer.values_ &&
        layer.values_.hasOwnProperty("id") &&
        layerId === layer.get("id")
      ) {
        throw new Error(`addGeojsonLayer: 图层id：${layerId}重复`);
      }
    });
    // 添加图层
    const vLayer = new VectorLayer({
      id: layerId,
      source: new VectorSource({
        features: new GeoJSON({ featureProjection: "EPSG:3857" }).readFeatures(
          geoJson
        ),
      }),
      style: style,
    });
    olMap.addLayer(vLayer);
  },

  /**
   * 快速添加GeoJson点图层
   * @param {*} layerId
   * @param {*} geoJson
   * @param {*} style
   */
  addGeojsonPointLayer(layerId, geoJson) {
    // layerId 唯一性
    olMap.getLayers().forEach((layer) => {
      // eslint-disable-next-line no-prototype-builtins
      if (
        layer &&
        layer.values_ &&
        layer.values_.hasOwnProperty("id") &&
        layerId === layer.get("id")
      ) {
        throw new Error(`addGeojsonLayer: 图层id：${layerId}重复`);
      }
    });

    const Features = new GeoJSON({
      featureProjection: "EPSG:3857",
    }).readFeatures(geoJson);

    console.log(Features.length, "Features");

    var styleFunction = function (feature) {
      return new Style({
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({
            color: "rgba(255, 0, 0, 0.5)",
          }),
          stroke: new Stroke({ color: "yellow", width: 1 }),
        }),
        stroke: new Stroke({ color: "yellow", width: 1 }),
        text: new Text({
          text: feature.get("ZNAME"),
          font: "12px bold serif",
          fill: new Fill({
            color: "#000",
          }),
          stroke: new Stroke({
            color: "#fff",
            width: 2,
          }),
        }),
      });
    };

    // 添加图层
    const vLayer = new VectorLayer({
      id: layerId,
      source: new VectorSource({
        features: Features,
      }),
      style: styleFunction,
    });

    console.log(vLayer.features, "vLayer");

    olMap.addLayer(vLayer);
  },

  /**
   * 移除指定id的图层
   * @param {*} Ids
   */
  removeLayerByIds(Ids) {
    const tempIds = [...Ids];
    const layers = [];
    olMap.getLayers().forEach((layer) => {
      // eslint-disable-next-line no-prototype-builtins
      if (layer && layer.values_ && layer.values_.hasOwnProperty("id")) {
        const layerId = layer.get("id");
        if (layerId && tempIds.indexOf(layerId) !== -1) {
          // olMap.removeLayer(layer)
          layers.push(layer);
        }
      }
    });

    layers.forEach((l) => {
      olMap.removeLayer(l);
    });
  },

  /**
   * 定位到坐标点
   */
  Position(lat, lon) {
    var view = olMap.getView();
    view.setZoom(8);
    console.log(lat, "x");
    console.log(lon, "y");
    view.setCenter(transform([lat, lon], "EPSG:4326", "EPSG:3857"));
  },
};

export default oMapUtil;
